(function (window, $) {
  'use strict';

  const backTopButton = {

    init: function () {
      const _this = this;

      return new Promise(resolve => {
        document.querySelector('body')._addCustomEventListener('click', '.back-top', _this.scrollToTop.bind(_this));

        resolve();
      });

    },

    scrollToTop: function () {
      WebitScrollTo.scrollTo({ element: 'body' });
    }

  };

  $(document).ready(function () {
    backTopButton.init();
  });

})(window, jQuery);
